import ContactRequestsDetail from './ContactRequestsDetail';

export default ContactRequestsDetail;


// WEBPACK FOOTER //
// ./src/components/ContactRequestsDetail/index.js